import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import { TextField } from "formik-material-ui";
import axios from "axios";
import { Box, Typography, Button } from "@mui/material";
import Accordion from "react-bootstrap/Accordion";
import RestoreIcon from "@mui/icons-material/Restore";
import DeleteIcon from "@mui/icons-material/Delete";
import LanguageIcon from "@mui/icons-material/Language";
import RadarIcon from "@mui/icons-material/Radar";
import DoneIcon from "@mui/icons-material/Done";
import AlertDisplay from "../../../componenets/AlertDisplay";

const APIkey = "dc589c8df9646ae392aa04934c242d0f";
const style = {
  width: "100%",
  backgroundColor: "lightgray",
  borderRadius: "4px",
  boxShadow:
    "rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset;",
};

const LanDetect = () => {
  const [languageList, setLanguageList] = useState([]);
  const [displaydata, setDisplayData] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [alertType, setAlertType] = useState("");
  const [showAlert, setShowAlert] = useState(true);
  const [history, setHistory] = useState(
    JSON.parse(localStorage.getItem("history")) || []
  );
  const [languagename, setLanguageName] = useState([]);

  const initialValues = {
    searchInput: "",
  };
  //detect language
  const getLanguage = async (payload) => {
    const url = "https://ws.detectlanguage.com/0.2/detect";
    try {
      const response = await axios.post(url, null, {
        headers: {
          Authorization: `Bearer ${APIkey}`,
        },
        params: {
          q: `${payload}`,
        },
      });
      if (response?.status === 200 || response?.status === 201) {
        return response?.data;
      }
    } catch (error) {
      return { error: error?.response?.data?.error?.message };
    }
  };

  useEffect(() => {
    localStorage.setItem("history", JSON.stringify(history));
    console.log("history", history);
  }, [history]);

  useEffect(() => {
    alert("Turn on CORS !!");
    getLanguageName();
  }, []);

  const onSubmit = async (values, submitProps) => {
    console.log("Form Data", values.searchInput);
    const value = values.searchInput;
    setHistory((old) => [...old, value]);
    const res = await getLanguage(values.searchInput);
    setLanguageList(res.data.detections);
    setAlertType("success");
    setAlertText("Detected!!");
    setShowAlert(true);
    setDisplayData(true);
  };

  const clearHistory = () => {
    console.log("clear");
    localStorage.removeItem("history");
    setAlertType("warning");
    setAlertText("Clear History Successfully!!");
    setShowAlert(true);
    setHistory("");
  };

  const getLanguageName = async () => {
    await axios
      .get("https://ws.detectlanguage.com/0.2/languages")
      .then((response) => {
        setLanguageName(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getfinalLanguage = (code) => {
    const language = languagename?.find((currdata) => {
      // return  languageList[0].language ===currdata.code;
      return code === currdata.code;
    });
    return language.name;
  };

  return (
    <div
      className="container shadow "
      style={{ marginTop: "25px", width: "500px" }}
    >
      <h3>
        {" "}
        <RadarIcon /> Language Detection
      </h3>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {(formik) => {
          return (
            <Form>
              <div className="accordion">
                <Field
                  id="searchInput"
                  name="searchInput"
                  type="text"
                  className="form-control"
                  placeholder="Search Word's language"
                  component={TextField}
                />
              </div>

              <button
                type="submit"
                className="btn btn-success"
                style={{ margin: "10px" }}
              >
                Submit
              </button>
              <button
                type="button"
                class="btn btn-warning"
                onClick={() => {
                  formik.resetForm();
                  setShowAlert(false);
                  setDisplayData(false);
                }}
              >
                Reset
              </button>
            </Form>
          );
        }}
      </Formik>
      <div className="container p-3">
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <RestoreIcon />
              Recent Search Value
            </Accordion.Header>
            <Accordion.Body>
              {history.length > 0 && (
                <Box sx={{ paddingX: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      p: 1,
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {history.length > 0 &&
                      history.map((val, index) => (
                        <Box
                          key={index}
                          sx={{
                            border: "1px solid gray",
                            borderRadius: "4px",
                            paddingX: 1,
                            color: "black",
                            fontSize: "20px",
                            backgroundColor: "lightgray",
                          }}
                        >
                          <Typography variant="subtitle1">{val}</Typography>
                        </Box>
                      ))}
                    <Button variant="outlined" onClick={clearHistory}>
                      {" "}
                      <Typography variant="subtitle1">
                        <DeleteIcon />
                      </Typography>
                    </Button>
                  </Box>
                </Box>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <br />
        {showAlert && alertType && alertText && (
          <AlertDisplay
            alertType={alertType}
            alertText={alertText}
            setShowAlert={setShowAlert}
          />
        )}
        {displaydata ? (
          <Typography variant="h6" gutterBottom>
            {" "}
            <LanguageIcon /> Languages:
          </Typography>
        ) : null}
        {displaydata
          ? languageList?.map((currdata, index) => {
              return (
                <List
                  sx={style}
                  component="nav"
                  aria-label="mailbox folders"
                  key={index}
                >
                  <ListItem>
                    {/* Language detect:{currdata?.language} */}
                    <DoneIcon /> {getfinalLanguage(currdata?.language)}
                  </ListItem>
                  <Divider />
                </List>
              );
            })
          : null}
      </div>
    </div>
  );
};

export default LanDetect;
